import { atom } from 'recoil';

/* 소프트폰 에서 수신인 리스트를 클릭하면 좌측 그룹 레이아웃에 해당하는 리스트에 active 하기 위한 recoil */
export const activeGroupRecoil = atom<{ groupSeqNo: number | null; groupNm: string | null; change: boolean } | null>({
  default: null,
  key: 'activeGroupRecoil',
});
